.filing-version-custom-tooltip{padding:15px;font-size:.95rem!important}
/*# sourceMappingURL=create-filing-from-arrangement-eat-dialog.component-334Q2CWM.css.map */
